export const CONTRACT_STATUS = {
  ENABLED: 'enabled',
  DISABLED: 'disabled',
}

export const CONTRACT_TYPE_SHARING = {
  PRODUCT_SHARING: 'productSharing',
  UPDATE_PRODUCT_SHARING: 'updateProductSharing',
  PRODUCT_AND_MODEL_SHARING: 'productAndModelSharing',
  PRODUCT_AND_3DSMAX_SHARING: 'productAnd3DSmaxSharing',
  HUBSTAIRS_TO_CUSTOMER: 'hubstairsToCustomer',
  CUSTOMER_TO_HUBSTAIRS: 'customerToHubstairs',
  VISUAL_SHARING: 'visualSharing',
  STAGE_TEMPLATE_SHARING: 'stageTemplateSharing',
  STAGE_TEMPLATE_AND_ASSET_SHARING: 'stageTemplateAnd3DSmaxSharing',
  EXPECTATION_SHARING: 'expectationSharing',
}

export const CONTRACT_TYPE_SOFTWARE = {
  RETAILER: 'retailer',
  JOBBER: 'jobber',
  NFINITE: 'nfinite',
  SUPPLIER: 'supplier',
}

export const CONTRACT_GROUPS = {
  JOBBER: 'jobber',
  RETAILER: 'retailer',
  SUPPLIER: 'supplier',
  NFINITE: 'nfinite',
}

export const CONTRACT_TYPE_SOFTWARE_GROUPS = {
  [CONTRACT_TYPE_SOFTWARE.RETAILER]: CONTRACT_GROUPS.RETAILER,
  [CONTRACT_TYPE_SOFTWARE.JOBBER]: CONTRACT_GROUPS.JOBBER,
  [CONTRACT_TYPE_SOFTWARE.NFINITE]: CONTRACT_GROUPS.NFINITE,
  [CONTRACT_TYPE_SOFTWARE.SUPPLIER]: CONTRACT_GROUPS.SUPPLIER,
}

export function getActiveMainContracts() {
  return {
    contractTypes: Object.values(CONTRACT_TYPE_SOFTWARE),
    statuses: [CONTRACT_STATUS.ENABLED],
  }
}

export const CONTRACT_REPORT_STATUSES = {
  SUCCESS: 'success',
  FAILED: 'failed',
}

export const CONTRACT_TYPE_RETAILER_GROUPS = [CONTRACT_TYPE_SOFTWARE.RETAILER]
